// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Segment, Grid } from 'semantic-ui-react'
import MetaData from './MetaData'

export default class CustomDev extends Component {
  render () {
    return (
      <Segment padded='very'>
        <Grid reversed='mobile' stackable verticalAlign='middle'>
          <Grid.Column width='8' textAlign='left'>
            <h3>Custom App Development</h3>
            <p>
              By reusing many of our existing modules and functionalities, you will only pay for the
              development of additional features, saving both time and money. Our app development
              platform is supporting truly native iOS and Android interface and performance.
            </p>
          </Grid.Column>
          <Grid.Column width='8' className='center'>
            <Button
              style={{
                backgroundColor: '#f7d170',
                borderColor: '#000',
                color: '#000',
                borderStyle: 'solid',
                borderWidth: '2px'
              }}
              href='/contact'
              size='big'>
              Get in touch
            </Button>
          </Grid.Column>
        </Grid>
        <MetaData />
      </Segment>
    )
  }
}
